import { Map } from 'immutable';
import { createReducer } from 'redux-act';

import ReservationConfirmationResult from '@/models/interfaces/ReservationConfirmationResult';
import { reservationConfirmationFailed, reservationConfirmationFinished } from '@/store/actions/reservation/confirmReservation';

export interface ConfirmReservationState {
  readonly reservationConfirmationResults: Map<string, { reservationConfirmationResult: ReservationConfirmationResult }>;
}

const defaultState: ConfirmReservationState = {
  reservationConfirmationResults: Map(),
};

const confirmReservationReducer = createReducer<ConfirmReservationState>({}, defaultState);

confirmReservationReducer.on(reservationConfirmationFinished, (state, { reservationConfirmationResult, token }) => {
  const { reservationConfirmationResults, ...others } = state;
  return { ...others, reservationConfirmationResults: reservationConfirmationResults.set(token, { reservationConfirmationResult }) };
});

confirmReservationReducer.on(reservationConfirmationFailed, (state, { reservationConfirmationResult, token }) => {
  const { reservationConfirmationResults, ...others } = state;
  return { ...others, reservationConfirmationResults: reservationConfirmationResults.set(token, { reservationConfirmationResult }) };
});

export default confirmReservationReducer;
